import { createFileRoute } from '@tanstack/react-router';

// relative imports
import AccountDisabledPage from '../../../../../components/account-management/AccountDisabledPage';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/disabled',
)({
  component: AccountDisabledPage,
  pendingComponent: () => <LoadingPage loadingPage hideSecondaryMenu />,
  staticData: {
    hideSecondaryMenu: true,
    isClientRoute: true,
    meta: {
      title: 'Account Disabled | Ledgible',
    },
  },
});
